import { Component, OnInit } from "@angular/core";
import { MetaService } from "../meta.service";

@Component({
	selector: "featured-partners",
	templateUrl: "./featured-partners.component.html",
	styleUrls: ["./featured-partners.component.css"],
})
export class FeaturedPartnersComponent implements OnInit {
	swiperConfig: any = {
		centeredSlides: true,
		spaceBetween: 30,
		breakpoints: {
			320: {
				slidesPerView: 2,
			},
			360: {
				slidesPerView: 2.5,
			},
			576: {
				slidesPerView: 3.3,
			},
		},
		loop: true,
	};

	//inject services
	constructor(private mds: MetaService) {}

	//initialize the component
	ngOnInit(): void {
		//SEO Optimization
	}
}
